import React, { useState } from "react";
import axiosInstance from "../axiosInterceptor";
import { ImageLink } from "../utils/constant";
import { X } from "lucide-react";
import { toast } from "react-toastify";

const SingleImageUploader = ({
  label = "Upload Image",
  apiEndpoint = "status/uploadFile",
  value,
  onChange,
}) => {
  const [loading, setLoading] = useState(false);

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("image", file);

      const res = await axiosInstance.post(apiEndpoint, formData);
      const uploadedPath = res.data?.path?.[0];

      if (uploadedPath) {
        onChange(uploadedPath);
      }
    } catch (err) {
      console.error("Image upload failed", err);
    } finally {
      setLoading(false);
    }
  };

  const removeImage = async (path) => {
    try {
      const response = await axiosInstance.post("/blog/deleteBlogImages", {
        data: { path: path },
      });
      toast.success(response.data.message);
    } catch (err) {
      toast.error(err?.response?.data?.message);
    }
    onChange("");
  };

  return (
    <div className="form-group mb-3">
      <label className="form-label fw-semibold">{label}</label>

      <input
        type="file"
        accept="image/*"
        className="form-control form-control-sm"
        onChange={handleFileChange}
      />

      {loading && (
        <div className="mt-2 text-muted small">Uploading...</div>
      )}

      {value && (
        <div className="mt-2 position-relative">
          <img
            src={ImageLink(value)}
            alt="Preview"
            style={{
              width: "100%",
              maxHeight: "160px",
              objectFit: "cover",
              borderRadius: "6px",
              border: "1px solid #ced4da",
            }}
          />

          <button
            type="button"
            className="btn btn-sm btn-danger position-absolute"
            style={{ top: 5, right: 5 }}
            onClick={() => removeImage(value)}
          >
            <X size={14} />
          </button>
        </div>
      )}
    </div>
  );
};

export default SingleImageUploader;
